import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["isTX0120Variant", "isTX0120Fetched", "isEligibleForTX0120", "isUpgradeModal"];
import { upgradeProductToTrialIds } from 'self-service-api/constants/Trials';
import TrialActivationButton from '../_core/trial/activation/TrialActivationButton';
import { useMultiTrialTrackingProps } from '../_core/trial/useMultiTrialTrackingProps';
import { TRIAL_STANDARD_DURATION } from '../_core/trial/constants';
import { mapPurchaseMotionApiName } from '../ums/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const updateUpgradeData = props => {
  const {
    upgradeData: {
      app,
      screen,
      uniqueId,
      duration
    }
  } = props;
  const isScreenUrlPath = screen.split('/').length > 1;
  const source = isScreenUrlPath ? uniqueId // Special case for UMS modals (uniqueId === upgradeKey)
  : `${app}-${screen}-trial-button-${uniqueId}`;
  return Object.assign({}, props, {
    upgradeData: Object.assign({}, props.upgradeData, {
      apiName: mapPurchaseMotionApiName(props.canViewNewSeats, props.upgradeData.upgradeProduct, 'UITrialActivationButton', props.upgradeData.apiName),
      source,
      trialId: upgradeProductToTrialIds[props.upgradeData.upgradeProduct] || null,
      duration: duration || TRIAL_STANDARD_DURATION
    })
  });
};
const UITrialActivationButton = _ref => {
  let {
      isTX0120Variant = false,
      isTX0120Fetched = false,
      isEligibleForTX0120 = false,
      isUpgradeModal = false
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    activeTrials,
    expiredTrials,
    isMultiTrial,
    isLoadingTrackingProps
  } = useMultiTrialTrackingProps();
  return /*#__PURE__*/_jsx(TrialActivationButton, Object.assign({}, updateUpgradeData(props), {
    activeTrials: activeTrials,
    expiredTrials: expiredTrials,
    isMultiTrial: isMultiTrial,
    canViewNewSeats: props.canViewNewSeats,
    isTX0120Variant: isTX0120Variant,
    isTX0120Fetched: isTX0120Fetched,
    isEligibleForTX0120: isEligibleForTX0120,
    isUpgradeModal: isUpgradeModal,
    isLoadingTrackingProps: isLoadingTrackingProps
  }));
};
export default UITrialActivationButton;